
export const returnTrackingNumber =
{
  "idShort": "ReturnTrackingNumber",
  "displayName": [
    {
      "language": "en",
      "text": "Return Tracking Number"
    },
    {
      "language": "de",
      "text": "R\u00FCcksendeverfolgungsnummer"
    }
  ],
  "value": "",
  "valueType": "xs:string",
  "modelType": "Property"
};